var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumbArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41465 0.353605C1.02412 -0.0369189 0.470104 -0.116065 0.17721 0.176829C-0.115683 0.469722 -0.0365372 1.02374 0.353987 1.41427L2.93974 4.00001L0.353534 6.58622C-0.0369906 6.97674 -0.116137 7.53076 0.176757 7.82365C0.46965 8.11655 1.02367 8.0374 1.41419 7.64688L4.24262 4.81845C4.48473 4.57634 4.60716 4.2714 4.59546 4.0048C4.61039 3.73605 4.48794 3.4269 4.24307 3.18203L1.41465 0.353605Z",
    fill: "#7C7E81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbArrow);
export default __webpack_public_path__ + "static/media/breadcrumb_arrow.bf179ddc2ce04d235d3bb454b743b4cb.svg";
export { ForwardRef as ReactComponent };